module.exports = require('./helpers/bundle-url').getBundleURL('g9U4b') + "logo.c51670a8.svg";